
export default function ServiceAreas() {
  const nassauTowns = [
    'Hempstead', 'Oyster Bay', 'North Hempstead', 'Long Beach', 'Glen Cove',
    'Freeport', 'Valley Stream', 'Massapequa', 'Levittown', 'Hicksville',
    'Uniondale', 'East Meadow', 'Elmont', 'Franklin Square', 'Garden City',
    'Mineola', 'Westbury', 'Rockville Centre', 'Oceanside', 'Wantagh'
  ];

  const suffolkTowns = [
    'Brookhaven', 'Islip', 'Huntington', 'Babylon', 'Smithtown',
    'Riverhead', 'Southampton', 'Southold', 'East Hampton', 'Shelter Island',
    'Brentwood', 'Central Islip', 'Commack', 'Deer Park', 'Bay Shore',
    'Patchogue', 'Lindenhurst', 'West Islip', 'Coram', 'Hauppauge'
  ];

  return (
    <section id="service-areas" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm font-medium text-[#1E3A8A] tracking-wide mb-4">
            WHERE WE SERVE
          </p>
          <h2 className="text-4xl md:text-5xl font-semibold text-neutral-900 tracking-tight mb-6">
            Serving Nassau & Suffolk County
          </h2>
          <p className="text-lg text-neutral-500 max-w-2xl mx-auto">
            We proudly serve small businesses throughout Long Island. Whether you're in the heart of Nassau or the shores of Suffolk, we're here to help your business grow online.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Nassau County */}
          <div className="bg-neutral-50 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-[#1E3A8A] flex items-center justify-center mb-3">
                <i className="ri-map-pin-fill text-white text-lg"></i>
              </div>
              <h3 className="text-xl font-semibold text-neutral-900">Nassau County</h3>
            </div>
            <div className="flex flex-wrap gap-2">
              {nassauTowns.map((town) => (
                <span 
                  key={town}
                  className="text-sm text-neutral-600 bg-white px-3 py-1.5 rounded-full border border-neutral-200"
                >
                  {town}
                </span>
              ))}
            </div>
          </div>

          {/* Suffolk County */}
          <div className="bg-neutral-50 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-[#1E3A8A] flex items-center justify-center mb-3">
                <i className="ri-map-pin-fill text-white text-lg"></i>
              </div>
              <h3 className="text-xl font-semibold text-neutral-900">Suffolk County</h3>
            </div>
            <div className="flex flex-wrap gap-2">
              {suffolkTowns.map((town) => (
                <span 
                  key={town}
                  className="text-sm text-neutral-600 bg-white px-3 py-1.5 rounded-full border border-neutral-200"
                >
                  {town}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Why Local Matters */}
        <div className="bg-neutral-900 rounded-3xl p-10 md:p-14 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-[#1E3A8A] rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
          </div>
          
          <div className="relative z-10">
            <h3 className="text-2xl md:text-3xl font-semibold text-white mb-4">
              Why Choose a Local Long Island Agency?
            </h3>
            <p className="text-neutral-400 max-w-2xl mx-auto mb-8">
              We understand the Long Island market. From local SEO that targets your neighborhood to content that resonates with your community, we help you connect with customers right here on the Island.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
              <div className="text-center">
                <div className="text-3xl font-bold text-white mb-2">587+</div>
                <p className="text-sm text-neutral-400">Local Businesses Served</p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white mb-2">100+</div>
                <p className="text-sm text-neutral-400">Towns Served</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
